import { render, staticRenderFns } from "./ShowDistributors.vue?vue&type=template&id=2facb68d&scoped=true&"
import script from "./ShowDistributors.vue?vue&type=script&lang=js&"
export * from "./ShowDistributors.vue?vue&type=script&lang=js&"
import style0 from "./ShowDistributors.vue?vue&type=style&index=0&id=2facb68d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2facb68d",
  null
  
)

export default component.exports